import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { useT } from "@/lib/labels";

export const SearchBox = ({ className = "", testid = "header-search" }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const t = useT();
  const navigate = useNavigate();
  const box = useRef(null);

  useEffect(() => {
    if (!q.trim()) return setRes(null);
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => setRes(r.data)), 220);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const close = (e) => box.current && !box.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const go = (path) => { setOpen(false); setQ(""); navigate(path); };
  const submit = (e) => { e.preventDefault(); if (q.trim()) go(`/codex?q=${encodeURIComponent(q.trim())}`); };

  return (
    <div ref={box} className={`relative ${className}`}>
      <form onSubmit={submit} className="flex items-center gap-2 border border-[#c9a227]/70 bg-[#fbf7ec]/80 px-3 py-2 focus-within:shadow-[0_0_0_3px_rgba(201,162,39,0.25)] transition-shadow">
        <Search className="w-4 h-4 text-[#5e4a35]" />
        <input
          data-testid={`${testid}-input`}
          value={q}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder={t("nav.search")}
          className="bg-transparent outline-none text-sm w-full font-body placeholder:text-[#8a7a63]"
        />
      </form>
      {open && res && (
        <div data-testid={`${testid}-results`} className="absolute right-0 left-0 mt-2 vellum z-50 max-h-96 overflow-auto min-w-[18rem]">
          {res.articles?.length === 0 && res.books?.length === 0 && <p className="p-4 text-sm italic text-[#5e4a35]">No pages found.</p>}
          {res.articles?.map((a) => (
            <button key={a.slug} data-testid={`search-result-${a.slug}`} onClick={() => go(`/wiki/${a.slug}`)} className="w-full text-left flex gap-3 p-3 hover:bg-[#c9a227]/15 transition-colors border-b border-[#c9a227]/20">
              {(a.infobox_image || a.hero_image) && <img src={imgUrl(a.infobox_image || a.hero_image)} alt="" className="w-10 h-10 object-cover border border-[#c9a227]" />}
              <span><span className="block font-heading text-sm font-semibold">{a.title}</span><span className="block text-xs text-[#5e4a35]">{a.section_name}</span></span>
            </button>
          ))}
          {res.books?.map((b) => (
            <a key={b.slug} href={b.kindle_url || "#"} target="_blank" rel="noreferrer" className="flex gap-3 p-3 hover:bg-[#c9a227]/15 text-sm">
              <img src={imgUrl(b.cover_image)} alt="" className="w-8 h-12 object-cover" /> <span className="font-heading">{b.title} <em className="block text-xs">Book</em></span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
